import { withStyles } from '@material-ui/core/styles'
import Switch from '@material-ui/core/Switch'


const CustomSwitch = withStyles(theme => ({
  root: {
  },
  switchBase: {
    '&$checked': {
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#1A305A',
        opacity: 1,
      }
    },
    '&$disabled': {
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#A2CAEC',
        opacity: 1
      }
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp
    })
  },
  thumb: {
    color: '#FFFFFF',
  },
  track: {
    border: 'none',
    backgroundColor: '#A2CAEC',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border'])
  },
  checked: {
  },
  disabled: {
  }
}))(Switch)

export const LargeCustomSwitch = withStyles({
  root: {
    width: 42,
    height: 22,
    padding: 0,
    display: 'flex',
    marginRight: 8
  },
  switchBase: {
    padding: 2,
    '&$checked': {
      transform: 'translateX(19.5px)',
      '& + $track': {
        opacity: 1,
      },
    },
  },
  thumb: {
    width: 18,
    height: 18,
    boxShadow: 'none',
  },
  track: {
    borderRadius: 16,
    opacity: 1,
  },
  checked: {},
})(CustomSwitch)

export const SmallCustomSwitch = withStyles({
  root: {
    width: 34,
    height: 16,
    padding: 0,
    display: 'flex',
    marginRight: 8
  },
  switchBase: {
    padding: 2,
    '&$checked': {
      transform: 'translateX(18.5px)',
      '& + $track': {
        opacity: 1,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    borderRadius: 8,
    opacity: 1,
  },
  checked: {},
})(CustomSwitch)

export default CustomSwitch
